"use client";

// A default component entry is safe for the server to render and keeps the existing
// client-boundary gate's ban on named client helper imports intact.
export { ExportShellView as default } from "./ExportMain";
